enum AlertType {
  info = 'info',
  warning = 'warning',
  error = 'error',
  success = 'success',
}

export default AlertType;
export type VerifyAlertType = Utils.VerifyExtends<Model.Enum.AlertType, Utils.ValueOf<typeof AlertType>>;
